import type { PitchExerciseType, PitchIntervalLevel } from '@tunasong/music-lib'

/**
 * Pitch Trainer URL-param parsers:
 *   - `?mode=<tone|interval|vocalise|phrase>` pre-selects an exercise card.
 *   - `?level=<1|2|3>` pre-selects the interval difficulty (interval-only; the welcome screen
 *     owns that gating and silently ignores it elsewhere).
 *
 * Unknown or missing values return `null` so the welcome screen renders with no pre-selection
 * and the user picks — the same contract Ear Training's parsers have.
 *
 * Spec: docs/superpowers/specs/2026-09-06-vocal-pitch-training-design.md §6
 */

export const parseExerciseType = (raw: string | null): PitchExerciseType | null => {
  if (raw === 'tone' || raw === 'interval' || raw === 'vocalise' || raw === 'phrase') {
    return raw
  }
  return null
}

export const parseIntervalLevel = (raw: string | null): PitchIntervalLevel | null => {
  if (raw === '1' || raw === '2' || raw === '3') {
    return Number(raw) as PitchIntervalLevel
  }
  return null
}
